/* Mistify Blend Bar — shared by the RDA design preview (window.MP_BLEND.data inline) and the live theme section
   (window.MP_BLEND = {dataUrl, variants, live:true}). Source: build/blend/, built by assemble.py + theme_build.py. */
(() => {
'use strict';
const CFG = window.MP_BLEND || {};
const boot = RAW => {
/* ---------- data ---------- */
const NOTES = RAW.notes, FAMS = RAW.fams;
const F = RAW.rows.map(r => ({h:r[0], title:r[1], scent:r[2], house:r[3],
  img: r[4] ? (RAW.base + r[4]) : '', aud:r[5], fam:FAMS[r[6]], top:r[7], mid:r[8], base:r[9]}));
const BY = Object.fromEntries(F.map(f => [f.h, f]));
const img = (f, w) => f.img ? f.img + (f.img.includes('?') ? '&' : '?') + 'width=' + w : '';
const GROUPS = [
  {k:'Amber',   c:'#D8A657', re:/oriental|amber|incense|oud/},
  {k:'Woody',   c:'#A07B5A', re:/wood|chypre|vetiver|sandal/},
  {k:'Floral',  c:'#DBA3B0', re:/floral|rose|flower/},
  {k:'Fresh',   c:'#9CC7BE', re:/citrus|aromatic|fresh|aquatic|green|fougere|fougère/},
  {k:'Gourmand',c:'#C99A73', re:/gourmand|vanilla/},
  {k:'Leather', c:'#8C6A58', re:/leather/},
  {k:'Spicy',   c:'#C77E5C', re:/spic/},
  {k:'Fruity',  c:'#E3B27B', re:/fruit/},
  {k:'Musk',    c:'#C9C0B6', re:/musk/}
];
const groupsOf = fam => { const s = (fam||'').toLowerCase(); return GROUPS.filter(g => g.re.test(s)); };
const primaryGroup = fam => { const s=(fam||'').toLowerCase(); const w=s.split(/\s+/)[0]||''; return GROUPS.find(g=>g.re.test(w)) || groupsOf(fam)[0] || null; };
F.forEach(f => { f.groups = groupsOf(f.fam).map(g => g.k);
  f.search = [f.title, f.scent, f.house, f.fam, ...[...f.top, ...f.mid, ...f.base].map(i => NOTES[i])].join(' ').toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g,''); });

/* ---------- pricing (mirrors the Shopify variants: Size × Strength × Fragrances 2–5) ---------- */
const BASE = {50:70, 100:100}, STRONG = 5, EXTRA = 5, MAX = 5, MIN = 5, STEP = 5;
const ORD = ['First','Second','Third','Fourth','Fifth'];
const COLORS = ['#D6A24E','#C4727A','#7FA07A','#8C7BB5','#5B8DB0'];

/* ---------- state ---------- */
const S = {slots:[], size:50, conc:20, name:''};
let pickFor = null;        // index being replaced, or 'new'
let filter = 'All';

/* ---------- balance maths (all values are multiples of 5 and sum to 100) ---------- */
const sum = a => a.reduce((x,y)=>x+y,0);
function distribute(idx, units, weights){      // give each at least 1 unit, rest by weight, largest remainder
  const n = idx.length; if(!n) return [];
  const extra = units - n; const w = weights.map(v => Math.max(0,v));
  const tw = sum(w); const share = w.map(v => tw ? v/tw*extra : extra/n);
  const fl = share.map(Math.floor); let left = extra - sum(fl);
  share.map((v,i)=>[v-fl[i],i]).sort((a,b)=>b[0]-a[0]).forEach(([,i]) => { if(left>0){fl[i]++;left--;} });
  return fl.map(v => (v+1)*STEP);
}
function freeOthers(i){ return S.slots.map((s,j)=>j).filter(j => j!==i && !S.slots[j].lock); }
function lockedSum(i){ return sum(S.slots.filter((s,j)=>j!==i && s.lock).map(s=>s.pct)); }
function maxFor(i){
  const free = freeOthers(i);
  if(!free.length) return S.slots[i].pct;
  return 100 - lockedSum(i) - MIN*free.length;
}
function setPct(i, v){
  const free = freeOthers(i); if(!free.length) return false;
  v = Math.max(MIN, Math.min(maxFor(i), Math.round(v/STEP)*STEP));
  if(v === S.slots[i].pct) return false;
  const R = 100 - lockedSum(i) - v;
  const vals = distribute(free, R/STEP, free.map(j => S.slots[j].pct - MIN));
  S.slots[i].pct = v; free.forEach((j,k) => S.slots[j].pct = vals[k]);
  return true;
}
function even(){             // a fresh start: releases every lock and splits the bottle evenly
  if(!S.slots.length) return;
  S.slots.forEach(s=>s.lock=false);
  const vals = distribute(S.slots.map((s,j)=>j), 100/STEP, S.slots.map(()=>1));
  S.slots.forEach((s,j)=>s.pct = vals[j]);
}
function addFragrance(h){
  const used = S.slots.map(s=>s.color);
  const color = COLORS.find(c=>!used.includes(c));
  if(!S.slots.length){ S.slots.push({h, pct:100, lock:false, color, fresh:true}); return; }
  let free = S.slots.map((s,j)=>j).filter(j=>!S.slots[j].lock);
  if(!free.length){ S.slots.forEach(s=>s.lock=false); free = S.slots.map((s,j)=>j); toast('Locks released to make room'); }
  const avail = sum(free.map(j=>S.slots[j].pct));
  const share = Math.max(MIN, Math.round(avail/(free.length+1)/STEP)*STEP);
  const vals = distribute(free, (avail-share)/STEP, free.map(j=>S.slots[j].pct-MIN));
  free.forEach((j,k)=>S.slots[j].pct = vals[k]);
  S.slots.push({h, pct:share, lock:false, color, fresh:true});
}
function removeFragrance(i){
  const gone = S.slots.splice(i,1)[0];
  if(!S.slots.length) return;
  let free = S.slots.map((s,j)=>j).filter(j=>!S.slots[j].lock);
  if(!free.length){ S.slots.forEach(s=>s.lock=false); free = S.slots.map((s,j)=>j); }
  const R = 100 - sum(S.slots.filter(s=>s.lock).map(s=>s.pct));
  const vals = distribute(free, R/STEP, free.map(j=>S.slots[j].pct));
  free.forEach((j,k)=>S.slots[j].pct = vals[k]);
  return gone;
}
const formula = n => BASE[S.size] + (S.conc===40?STRONG:0) + Math.max(0,n-2)*EXTRA;
const variantFor = () => (CFG.variants || {})[`${S.size}|${S.conc}|${Math.max(2,S.slots.length)}`];
const price = () => { const v = CFG.variants && variantFor(); return v ? Math.round(v.price/100) : formula(S.slots.length); };
const ready = () => S.slots.length >= 2 && sum(S.slots.map(s=>s.pct)) === 100;

/* ---------- helpers ---------- */
// Horizon on this store scrolls .page-wrapper, not the window, so lock both while a panel is open
const lockScroll = on => [document.body, document.querySelector('.page-wrapper')].forEach(el => { if(el) el.style.overflow = on ? 'hidden' : ''; });
const $ = s => document.querySelector(s);
const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const money = v => '$' + v;
let toastT; function toast(m){ const t=$('#toast'); t.textContent=m; t.classList.add('show'); clearTimeout(toastT); toastT=setTimeout(()=>t.classList.remove('show'),2200); }
const ICON_LOCK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="7" width="10" height="7" rx="1.5"/><path d="M5.5 7V5a2.5 2.5 0 015 0v2"/></svg>';
const ICON_OPEN = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="7" width="10" height="7" rx="1.5"/><path d="M5.5 7V5a2.5 2.5 0 014.9-.7"/></svg>';
const ICON_X = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 4l8 8M12 4l-8 8"/></svg>';

/* ---------- render: slots ---------- */
function track(s, i){
  const m = S.slots.length < 2 ? s.pct : maxFor(i);
  return `linear-gradient(to right, ${s.color} 0 ${s.pct}%, #ebe6e1 ${s.pct}% ${m}%, transparent ${m}%), repeating-linear-gradient(135deg,#ebe6e1 0 3px,#fff 3px 6px)`;
}
function noteFor(s, i){
  if(S.slots.length < 2) return 'Add a second fragrance to start blending';
  if(s.lock) return 'Locked at ' + s.pct + '%';
  if(!freeOthers(i).length) return 'Unlock another fragrance to adjust this one';
  return '';
}
function renderSlots(){
  const el = $('#slots'); let html = '';
  S.slots.forEach((s,i) => {
    const f = BY[s.h];
    html += `<div class="slot${s.fresh?' enter':''}" style="--c:${s.color}" data-i="${i}">
      <div class="slot-top">
        <div class="thumb">${f.img?`<img src="${esc(img(f,160))}" alt="" loading="lazy">`:''}</div>
        <button class="who" data-act="swap" data-i="${i}" aria-label="Change ${esc(f.title)}">
          <span class="t">${esc(f.title)}</span>
          <span class="ib">Inspired by <em>${esc(f.scent)}</em> · ${esc(f.house)}</span>
          <span class="swap">Change</span>
        </button>
        <div class="pct">
          <output id="o${i}">${s.pct}<small>%</small></output>
          <button class="ico" data-act="lock" data-i="${i}" aria-pressed="${s.lock}" aria-label="${s.lock?'Unlock':'Lock'} ${esc(f.title)}">${s.lock?ICON_LOCK:ICON_OPEN}</button>
          <button class="ico" data-act="rm" data-i="${i}" aria-label="Remove ${esc(f.title)}">${ICON_X}</button>
        </div>
      </div>
      <div class="range"><input type="range" min="0" max="100" step="5" value="${s.pct}" data-i="${i}" aria-label="${esc(f.title)} percentage" style="--c:${s.color};--track:${track(s,i)}" ${(S.slots.length<2||s.lock||!freeOthers(i).length)?'disabled':''}></div>
      <div class="range-note" id="n${i}">${noteFor(s,i)}</div>
    </div>`;
    s.fresh = false;
  });
  for(let k = S.slots.length; k < 2; k++){
    html += `<button class="empty" data-act="pick"><span class="plus">+</span><span><b>Choose your ${ORD[k].toLowerCase()} fragrance</b><span>Search by name, the original, the house or a note</span></span></button>`;
  }
  el.innerHTML = html;
  const add = $('#addBtn');
  add.disabled = S.slots.length < 2 || S.slots.length >= MAX;
  add.innerHTML = S.slots.length >= MAX ? 'Five fragrances is the maximum' : `+ Add another fragrance <span>+${money(EXTRA)}</span>`;
  $('#evenBtn').style.display = S.slots.length >= 2 ? '' : 'none';
}
function updateSliders(except){      // live update without rebuilding the DOM (keeps the drag going)
  S.slots.forEach((s,i) => {
    const r = document.querySelector(`input[type=range][data-i="${i}"]`);
    if(!r) return;
    if(i !== except) r.value = s.pct;
    r.style.setProperty('--track', track(s,i));
    $('#o'+i).innerHTML = s.pct + '<small>%</small>';
    $('#n'+i).textContent = noteFor(s,i);
  });
}

/* ---------- render: stage ---------- */
const layersEl = $('#layers'), waveEl = $('#wave'), bubblesEl = $('#bubbles');
const GLASS = {x:56, y:134, w:128, h:158}, FILL = .9;   // liquid chamber inside the Mistify flacon (thick glass base below)
let shown = [];   // animated layer heights
function targets(){ return S.slots.map(s => ({c:s.color, v:s.pct})); }
function drawBottle(t){
  const tg = targets();
  while(shown.length < tg.length) shown.push({c:tg[shown.length].c, v:0});
  shown.length = Math.max(tg.length, 0);
  let moving = false;
  shown.forEach((l,i) => { const g = tg[i] ? tg[i].v : 0; l.c = tg[i] ? tg[i].c : l.c;
    const d = g - l.v; if(Math.abs(d) > .05){ l.v += d*.14; moving = true; } else l.v = g; });
  const total = sum(shown.map(l=>l.v));
  const fillH = GLASS.h * FILL * Math.min(1,total/100);
  let y = GLASS.y + GLASS.h; let svg = '';
  shown.forEach(l => { const hh = fillH * (l.v/Math.max(total,1)) ; y -= hh;
    svg += `<rect x="${GLASS.x-10}" y="${(y-3).toFixed(2)}" width="${GLASS.w+20}" height="${(hh+6).toFixed(2)}" fill="${l.c}"/>`; });
  layersEl.innerHTML = svg;
  const top = GLASS.y + GLASS.h - fillH, ph = t/900;
  if(fillH > 1){
    let d = `M${GLASS.x} ${top}`;
    for(let x=0; x<=GLASS.w; x+=8){ d += ` L${GLASS.x+x} ${(top + Math.sin(ph + x/22)*2.2).toFixed(2)}`; }
    d += ` L${GLASS.x+GLASS.w} ${top+10} L${GLASS.x} ${top+10} Z`; waveEl.setAttribute('d', d);
  } else waveEl.setAttribute('d','');
  return moving;
}
let bubbleT = 0;
function bubbles(){
  if(!S.slots.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let html = '';
  for(let i=0;i<7;i++){ const x = 64 + Math.random()*112, r = 1.5+Math.random()*2.5, d = 1.4+Math.random()*1.6, dl = Math.random()*.6;
    html += `<circle cx="${x.toFixed(1)}" cy="288" r="${r.toFixed(1)}" fill="rgba(255,255,255,.35)"><animate attributeName="cy" from="288" to="${(150+Math.random()*60).toFixed(0)}" dur="${d.toFixed(2)}s" begin="${dl.toFixed(2)}s" fill="freeze"/><animate attributeName="opacity" values="0;.9;0" dur="${d.toFixed(2)}s" begin="${dl.toFixed(2)}s" fill="freeze"/></circle>`; }
  bubblesEl.innerHTML = html; clearTimeout(bubbleT); bubbleT = setTimeout(()=>bubblesEl.innerHTML='', 3200);
}
(function loop(t){ drawBottle(t); requestAnimationFrame(loop); })(0);

function renderStage(){
  const n = S.slots.length;
  $('#bottle').classList.toggle('s50', S.size === 50);
  const nm = S.name.trim();
  const auto = S.slots.map(s=>BY[s.h].title);
  $('#stName').textContent = nm || (n ? auto.slice(0,2).join(' × ') + (n>2 ? ` + ${n-2}` : '') : 'Untitled blend');
  $('#stName').classList.toggle('ph', !nm && !n);
  $('#label').setAttribute('opacity', n ? '1' : '0');
  const lbl = (nm || 'MY BLEND').toUpperCase().slice(0,15);
  $('#lblName').textContent = lbl;
  // the gold label's name line is 66 units wide: shrink long names to fit it
  $('#lblName').setAttribute('font-size', Math.min(9, (66 / lbl.length - .8) / .66).toFixed(2));
  const st = $('#status');
  st.className = 'status' + (ready() ? ' ok' : '');
  st.querySelector('span').textContent = ready() ? 'Balanced at 100%' : (n === 1 ? 'Choose one more' : 'Choose two fragrances');
  $('#legend').innerHTML = n ? S.slots.map(s=>`<div class="lg" style="--c:${s.color}"><i></i><span>${esc(BY[s.h].title)}</span><b>${s.pct}%</b></div>`).join('')
    : '<p class="lg-empty">Pick your first fragrance and watch the bottle fill.</p>';
  const barHtml = S.slots.map(s=>`<i style="--c:${s.color};width:${s.pct}%"></i>`).join('');
  $('#bar').innerHTML = barHtml; $('#miniBar').innerHTML = barHtml;
  renderCharacter(); renderPrice();
  document.documentElement.style.setProperty('--glow', n ? S.slots[0].color : '#D6A24E');
}
function renderCharacter(){
  const withNotes = S.slots.filter(s => { const f=BY[s.h]; return f.top.length||f.mid.length||f.base.length||f.fam; });
  const el = $('#character');
  if(!withNotes.length){ el.innerHTML = '<p class="none">' + (S.slots.length ? 'We do not have notes on file for this fragrance yet.' : 'The scent profile builds here as you choose fragrances.') + '</p>'; return; }
  const fam = {}; let ft = 0;
  withNotes.forEach(s => { const g = primaryGroup(BY[s.h].fam); if(g){ fam[g.k]=(fam[g.k]||0)+s.pct; ft+=s.pct; } });
  const famHtml = ft ? '<div class="fam">' + GROUPS.filter(g=>fam[g.k]).sort((a,b)=>fam[b.k]-fam[a.k]).map(g =>
    `<i style="width:${(fam[g.k]/ft*100).toFixed(1)}%;background:${g.c}" title="${g.k} ${Math.round(fam[g.k]/ft*100)}%">${fam[g.k]/ft>.16?g.k:''}</i>`).join('') + '</div>' : '';
  const tier = key => { const acc = {};
    withNotes.forEach(s => BY[s.h][key].forEach((ni,pos) => { acc[ni] = (acc[ni]||0) + s.pct * (1 - pos*.12); }));
    const list = Object.entries(acc).sort((a,b)=>b[1]-a[1]).slice(0,5); if(!list.length) return '';
    const mx = list[0][1]; return '<div class="chips">' + list.map(([ni,w]) => `<span class="chip" style="opacity:${(.45+.55*w/mx).toFixed(2)}">${esc(NOTES[ni])}</span>`).join('') + '</div>'; };
  const t = tier('top'), m = tier('mid'), b = tier('base');
  el.innerHTML = famHtml + '<div class="tiers">' +
    (t?`<div class="tier"><span>Opens with</span>${t}</div>`:'') + (m?`<div class="tier"><span>Heart</span>${m}</div>`:'') + (b?`<div class="tier"><span>Dries down to</span>${b}</div>`:'') + '</div>';
}
let priceShown = price();
function renderPrice(){
  const n = S.slots.length, p = price();
  let rows = `<div><span>${S.size} ml bottle</span><span>${money(BASE[S.size])}</span></div>`;
  if(S.conc === 40) rows += `<div><span>40% strength</span><span>+${money(STRONG)}</span></div>`;
  for(let k=2;k<n;k++) rows += `<div><span>${ORD[k]} fragrance</span><span>+${money(EXTRA)}</span></div>`;
  rows += `<div class="tot"><span>Total</span><b id="tot">${money(priceShown)}</b></div>`;
  $('#price').innerHTML = rows;
  tweenPrice(p);
  const ok = ready();
  $('#cta').disabled = !ok; $('#dockCta').disabled = !ok;
  $('#cta').textContent = ok ? `Add blend to cart · ${money(p)}` : (n ? 'Choose one more fragrance' : 'Choose two fragrances');
  $('#dockSub').textContent = ok ? `${S.size} ml · ${S.conc}% strength` : (n ? 'Choose one more fragrance' : 'Choose two fragrances');
  $('#miniTxt').textContent = ok ? `Your blend · ${n} fragrances · ${S.size} ml` : (n ? 'Choose one more fragrance' : 'Choose two fragrances to start');
}
let priceRaf;
function tweenPrice(to){
  cancelAnimationFrame(priceRaf); const from = priceShown, t0 = performance.now();
  const step = t => { const k = Math.min(1,(t-t0)/450), e = 1-Math.pow(1-k,3); priceShown = Math.round(from + (to-from)*e);
    ['#tot','#dockPrice','#miniPrice'].forEach(s => { const el=$(s); if(el) el.textContent = money(priceShown); });
    if(k<1) priceRaf = requestAnimationFrame(step); };
  priceRaf = requestAnimationFrame(step);
}
function renderAll(){ renderSlots(); renderStage(); saveHash(); }

/* ---------- events: builder ---------- */
$('#slots').addEventListener('input', e => {
  const r = e.target; if(r.type !== 'range') return;
  const i = +r.dataset.i; const want = +r.value;
  setPct(i, want);
  if(+r.value !== S.slots[i].pct) r.value = S.slots[i].pct;
  updateSliders(i); renderStage(); saveHash();
});
$('#slots').addEventListener('change', e => { if(e.target.type === 'range') bubbles(); });
$('#slots').addEventListener('click', e => {
  const b = e.target.closest('[data-act]'); if(!b) return;
  const i = +b.dataset.i, act = b.dataset.act;
  if(act === 'pick') openPicker('new');
  if(act === 'swap') openPicker(i);
  if(act === 'lock'){ S.slots[i].lock = !S.slots[i].lock; renderAll(); }
  if(act === 'rm'){ const g = removeFragrance(i); renderAll(); if(g) toast(BY[g.h].title + ' removed'); }
});
$('#addBtn').onclick = () => openPicker('new');
$('#evenBtn').onclick = () => { even(); renderAll(); bubbles(); };
$('#surpriseBtn').onclick = () => surpriseBlend();
document.querySelectorAll('input[name=size]').forEach(r => r.onchange = () => { S.size = +r.value; renderStage(); saveHash(); });
document.querySelectorAll('input[name=conc]').forEach(r => r.onchange = () => { S.conc = +r.value; renderStage(); saveHash(); });
$('#nameIn').addEventListener('input', e => { S.name = e.target.value; renderStage(); saveHash(); });

function surpriseBlend(){
  const pool = F.filter(f => f.img && (f.top.length || f.fam));
  const k = 2 + Math.floor(Math.random()*2); const pick = [];
  while(pick.length < k){ const f = pool[Math.floor(Math.random()*pool.length)]; if(!pick.includes(f.h)) pick.push(f.h); }
  S.slots = []; pick.forEach(h => addFragrance(h));
  const splits = k === 2 ? [[60,40],[70,30],[55,45]] : [[50,30,20],[40,35,25],[45,30,25]];
  const sp = splits[Math.floor(Math.random()*splits.length)]; S.slots.forEach((s,i)=>s.pct = sp[i]);
  renderAll(); bubbles(); toast('A blend to start from. Change anything you like.');
}

/* ---------- picker ---------- */
const CHIPS = ['All','For him','For her','Unisex', ...GROUPS.map(g=>g.k)];
$('#fchips').innerHTML = `<button class="fc sur" data-f="__surprise">✦ Surprise me</button>` + CHIPS.map(c => `<button class="fc" data-f="${c}" aria-pressed="${c==='All'}">${c}</button>`).join('');
$('#fchips').addEventListener('click', e => { const b = e.target.closest('.fc'); if(!b) return;
  if(b.dataset.f === '__surprise'){ const pool = results().filter(f => !S.slots.some(s=>s.h===f.h)); if(pool.length) choose(pool[Math.floor(Math.random()*pool.length)].h); return; }
  filter = b.dataset.f; document.querySelectorAll('#fchips .fc[data-f]').forEach(x => x.setAttribute('aria-pressed', x.dataset.f===filter)); renderGrid(); });
function results(){
  const q = $('#q').value.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');
  const toks = q.split(/\s+/).filter(Boolean);
  let list = F.filter(f => {
    if(filter==='For him' && f.aud!=='m') return false;
    if(filter==='For her' && f.aud!=='w') return false;
    if(filter==='Unisex' && f.aud!=='u') return false;
    if(GROUPS.some(g=>g.k===filter) && !f.groups.includes(filter)) return false;
    return toks.every(t => f.search.includes(t));
  });
  if(toks.length){ const head = f => (f.title+' '+f.scent+' '+f.house).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');
    list.sort((a,b) => (toks.every(t=>head(b).includes(t)) - toks.every(t=>head(a).includes(t)))); }
  return list;
}
function renderGrid(){
  const list = results(), inBlend = new Set(S.slots.map(s=>s.h));
  const replacing = typeof pickFor === 'number' ? S.slots[pickFor].h : null;
  $('#pkMeta').textContent = list.length + (list.length===1?' fragrance':' fragrances') + ($('#q').value.trim() ? ' match' : '');
  $('#grid').innerHTML = list.length ? list.map(f => `<button class="pkc${inBlend.has(f.h)&&f.h!==replacing?' in':''}" data-h="${f.h}">
      <div class="im">${f.img?`<img src="${esc(img(f,360))}" alt="" loading="lazy">`:''}</div>
      <div class="tx"><span class="t">${esc(f.title)}</span><span class="ib">Inspired by <em>${esc(f.scent)}</em><br>${esc(f.house)}</span>${f.fam?`<span class="fm">${esc(f.fam)}</span>`:''}</div>
    </button>`).join('') : `<p class="noresult">Nothing matches that yet. Try the original's name, the house, or a note such as oud, rose or vanilla.</p>`;
}
let lastFocus;
function openPicker(which){
  pickFor = which; lastFocus = document.activeElement;
  const k = which === 'new' ? S.slots.length : which;
  $('#pkTitle').textContent = which === 'new' ? `Choose your ${ORD[k].toLowerCase()} fragrance` : `Replace ${BY[S.slots[which].h].title}`;
  renderGrid(); $('#ov').classList.add('open'); $('#pk').classList.add('open'); lockScroll(true);
  setTimeout(() => { if(matchMedia('(min-width: 961px)').matches) $('#q').focus(); else $('#pkClose').focus(); }, 60);
}
function closePicker(){ $('#ov').classList.remove('open'); $('#pk').classList.remove('open'); lockScroll(false); if(lastFocus) lastFocus.focus(); }
function choose(h){
  if(pickFor === 'new') addFragrance(h);
  else { S.slots[pickFor].h = h; S.slots[pickFor].fresh = true; }
  closePicker(); renderAll(); bubbles();
}
$('#grid').addEventListener('click', e => { const c = e.target.closest('.pkc'); if(c) choose(c.dataset.h); });
$('#q').addEventListener('input', renderGrid);
$('#pkClose').onclick = closePicker; $('#ov').onclick = closePicker;

/* ---------- add to cart (preview) ---------- */
function openDrawer(){
  const n = S.slots.length, nm = S.name.trim();
  const mini = document.getElementById('bottle').cloneNode(true); mini.removeAttribute('id'); mini.classList.remove('s50'); mini.style.maxWidth='72px';
  mini.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
  const props = [];
  if(nm) props.push(['Blend name', nm]);
  S.slots.forEach((s,i) => { const f = BY[s.h]; props.push([`Fragrance ${i+1}`, `${f.title} (inspired by ${f.scent}, ${f.house}) · ${s.pct}%`]); });
  $('#drBody').innerHTML = `<div class="li"><div class="lb"></div><div><h4>Mistify Blend Bar</h4><div class="v">${S.size} ml / ${S.conc}% / ${n} fragrances</div></div><div class="pr">${money(price())}</div></div>
    <dl class="props">${props.map(([k,v])=>`<div><dt>${esc(k)}</dt><dd>${esc(v)}</dd></div>`).join('')}</dl>
    <p class="note">Preview only. On the live site this goes to the cart and on to checkout, and the recipe above is printed on the order, the packing slip and the customer's confirmation email.</p>`;
  $('#drBody .lb').appendChild(mini);
  $('#ov2').classList.add('open'); $('#dr').classList.add('open'); lockScroll(true); setTimeout(()=>$('#drClose').focus(),50);
}
function closeDrawer(){ $('#ov2').classList.remove('open'); $('#dr').classList.remove('open'); lockScroll(false); }
function recipe(){
  const props = {};
  if(S.name.trim()) props['Blend name'] = S.name.trim();
  S.slots.forEach((s,i) => { const f = BY[s.h]; props[`Fragrance ${i+1}`] = `${f.title} ${s.pct}% (inspired by ${f.scent}, ${f.house})`; });
  props['_blend'] = S.slots.map(s=>s.h+':'+s.pct).join(',');     // machine-readable copy, hidden from the customer
  return props;
}
let adding = false;
async function addLive(){
  const v = variantFor();
  if(!v || !v.available){ toast('This combination is not available right now'); return; }
  if(adding) return; adding = true;
  const btns = [$('#cta'), $('#dockCta')]; btns.forEach(b => { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Adding…'; });
  let ev = null, deferred = null;
  try { ev = await import('@shopify/events'); deferred = ev.CartLinesUpdateEvent.createPromise(); } catch(e) {}
  const sections = [...document.querySelectorAll('cart-items-component')].map(c => c.dataset.sectionId).filter(Boolean);
  if(ev) document.dispatchEvent(new ev.CartLinesUpdateEvent({action:'add', context:'product', lines:[{merchandiseId: String(v.id), quantity:1}], promise: deferred.promise}));
  try {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const r = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify({items:[{id:v.id, quantity:1, properties:recipe()}], sections: sections.join(',')})});
    const res = await r.json();
    if(!r.ok || res.status){ throw new Error(res.description || res.message || 'Could not add to cart'); }
    const cart = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}}).then(x => x.json());
    if(deferred) deferred.resolve({cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail:{items: cart.items, source:'mp-blend-bar', sourceId:'mp-blend-bar', itemCount:1, sections: res.sections, didError:false}});
    toast('Your blend is in the cart');
  } catch(e) {
    if(deferred) deferred.reject(e);
    toast(e.message || 'Could not add to cart, please try again');
  } finally {
    adding = false; btns.forEach(b => { b.textContent = b.dataset.label; }); renderPrice();
  }
}
const onAdd = () => CFG.live ? addLive() : openDrawer();
$('#cta').onclick = onAdd; $('#dockCta').onclick = onAdd;
$('#drClose').onclick = closeDrawer; $('#ov2').onclick = closeDrawer; $('#drKeep').onclick = closeDrawer;
$('#drNew').onclick = () => { S.slots=[]; S.name=''; $('#nameIn').value=''; shown=[]; closeDrawer(); renderAll(); $('.bb').scrollIntoView({behavior:'smooth', block:'start'}); };
document.addEventListener('keydown', e => { if(e.key==='Escape'){ if($('#pk').classList.contains('open')) closePicker(); if($('#dr').classList.contains('open')) closeDrawer(); } });

/* ---------- shareable blends: #b=handle.60~handle.40&s=50&c=20&n=Name ---------- */
let hashT;   // debounced: Safari throws after 100 replaceState calls in 30 s, and a slider drag fires dozens
function saveHash(){ clearTimeout(hashT); hashT = setTimeout(writeHash, 400); }
function writeHash(){
  const p = new URLSearchParams();
  if(S.slots.length) p.set('b', S.slots.map(s=>s.h+'.'+s.pct).join('~'));
  if(S.size!==50) p.set('s', S.size); if(S.conc!==20) p.set('c', S.conc); if(S.name.trim()) p.set('n', S.name.trim());
  const h = p.toString(); try { history.replaceState(null, '', h ? '#' + h : location.pathname + location.search); } catch(e) {}
}
function loadHash(){
  const p = new URLSearchParams(location.hash.slice(1));
  const b = (p.get('b')||'').split('~').map(x => { const k = x.lastIndexOf('.'); return [x.slice(0,k), +x.slice(k+1)]; })
    .filter(([h,v]) => BY[h] && v >= MIN && v % STEP === 0).slice(0,MAX);
  if(b.length && sum(b.map(x=>x[1])) === 100 && new Set(b.map(x=>x[0])).size === b.length)
    S.slots = b.map(([h,v],i) => ({h, pct:v, lock:false, color:COLORS[i], fresh:true}));
  if(p.get('s')==='100'){ S.size=100; $('#s100').checked=true; }
  if(p.get('c')==='40'){ S.conc=40; $('#c40').checked=true; }
  if(p.get('n')){ S.name = p.get('n').slice(0,24); $('#nameIn').value = S.name; }
}
$('#shareBtn').onclick = async () => {
  if(!S.slots.length){ toast('Choose a fragrance first'); return; }
  clearTimeout(hashT); writeHash();
  try { await navigator.clipboard.writeText(location.href); toast('Link copied. Anyone who opens it sees this blend.'); }
  catch(e){ toast('Copy the address bar to share this blend'); }
};

loadHash(); renderAll();
};
if(CFG.data) boot(CFG.data);
else if(CFG.dataUrl) fetch(CFG.dataUrl).then(r => r.json()).then(boot).catch(e => { console.error('[blend-bar]', e);
  const s = document.getElementById('slots'); if(s) s.innerHTML = '<p>The Blend Bar could not load. Please refresh the page.</p>'; });
})();
